import { observer } from "mobx-react";
import * as React from "react";
import { Button, FormGroup, InputGroup } from "@blueprintjs/core";
import { observable } from "mobx";
import { MDBCol, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import { LoginStore } from "../../stores/login/LoginStore";
import Cookies from "universal-cookie";
import { AppStore } from "../../stores/AppStore";
import { GenerateStore } from "../../stores/2fa/GenerateStore";

@observer
export class AutenticacaoPage extends React.Component<{}, {}> {

  obs = observable({
    count: 50 as number,
    codigo_autenticacao: "" as string,
    disabled: true as boolean,
    loading: false as boolean
  })

  constructor(props: any) {
    super(props);
  }

  componentDidMount(): void {


    this.handleClock()
  }

  handleClock() {
    this.obs.count = 50;
    this.obs.disabled = true;
    let main = setInterval(() => {
      if (this.obs.count != 0) {
        this.obs.count = this.obs.count - 1;
      } else {
        clearInterval(main)
        this.obs.disabled = false;
      }
    }, 1000)
  }

  async handleSendEmail() {
    let resp = await LoginStore.handleResendToken(LoginStore.obs.email)

    if (resp.ok) {
      this.handleClock()
    } else {
      toast.error("Não foi possível enviar e-mail, tente novamente!", {});
    }
  }

  async handleAutenticar() {
    this.obs.loading = true

    let resp = await LoginStore.handleGetAutenticacao(this.obs.codigo_autenticacao)

    if (resp.ok) {
      // const cookies = new Cookies();
      // cookies.set('goto', resp.token, { path: '/', maxAge: 57600 });
      // cookies.set('goto_socket', resp.token_socket, { path: '/', maxAge: 57600 });
      toast.success("Conta autenticada!", {});

      this.obs.loading = false

      GenerateStore.obs.open2fa = false

      setInterval(() => { AppStore.setLocation("/"); }, 2000)
    } else {
      toast.error(resp.erro, {});
    }

    this.obs.loading = false
  }

  render() {

    return (
      <>
        <div className="container-fluid container-login">
          <MDBRow>
            <MDBCol md="6" className="form-login" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
              <div className="login-img">
                <img src="/images/logo-novo.png" className="img-responsive" />
              </div>

              <h2 className="title-login" style={{ textAlign: "center" }}>Por favor, autentique sua conta</h2>

              <p style={{ fontSize: "16px", textAlign: "center" }}>Foi encaminhado um código de 5 dígitos para seu E-mail e para seu celular via SMS. </p>

              <FormGroup
                className="form-group"
                label="Autenticação:">
                <InputGroup type="text" onChange={(e: any) => this.obs.codigo_autenticacao = e.target.value} className="input-email" />
              </FormGroup>

              <div className="actions-form">
                {!this.obs.loading
                  ? <Button className="btn btn-login" onClick={() => this.handleAutenticar()}>Autenticar</Button>
                  : <Button className="btn btn-login">
                    <i className="fa fa-spinner fa-spin"></i>
                    Autenticando
                  </Button>
                }
              </div>

              <div className="login-footer-login" style={{ marginBottom: 20 }}>
                  <div style={{ textAlign: "center" }}>
                    Não recebeu? <label style={{ cursor: "pointer" }} onClick={() => this.handleSendEmail()}><b style={{ color: "#3579EA" }}>Reenviar código</b></label>
                  </div>
              </div>

              <div style={{ textAlign: "center", fontSize: 15, marginTop: "auto", marginBottom: 20 }}>
                <div className="name-ent">Gerenciador Fiscal e Tributário Ltda.</div>
                <div>© 2023 . Todos os Direitos Reservados.</div>
              </div>

            </MDBCol>

            <MDBCol md="6" className="fundo-login">
              <div className="fundo-bg"></div>
            </MDBCol>
          </MDBRow>

        </div>
      </>
    );
  }
}

export default AutenticacaoPage;
